import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../components/Index'
import Fruit from '../components/Fruit'
import Fashion from '../components/Fashion'
import Aboutus from '../components/Aboutus.vue'
import Information from '../view/information/Information.vue'
import product from '../view/product/product.vue'
import company from '../view/company/company.vue'
import qualifications from '../components/qualifications'
Vue.use(VueRouter)

export default new VueRouter({
	mode: 'hash',
	routes: [
		{
			path: '/qualifications',
			name: 'qualifications',
			component: qualifications,
			meta: {
				title: '服务资格证书'
			}
		},
		{
			path: '/',
			name: 'Index',
			component: Index
		},
		{
			path: '/fruit',
			name: 'Fruit',
			component: Fruit
		},
		{
			path: '/fashion',
			name: 'Fashion',
			component: Fashion
		}, {
			path: '/Aboutus',
			name: 'Aboutus',
			component: Aboutus
		}, {
			path: '/Information',
			name: 'Information',
			component: Information
		}, {
			path: '/product',
			name: 'product',
			component: product
		},
		{
			path: '/company',
			name: 'company',
			component: company
		}
	],
	//配置滚动行为，跳转到新的路由界面滚动条的位置
	scrollBehavior() {
		return {
			x: 0,
			y: 0
		}
	}
})
